import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { drawerWidth } from "styles/constants";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      background: "linear-gradient(to bottom, #673368, #CF939C)",
      border: "none",
      width: drawerWidth,
    },
    lightDivider: {
      backgroundColor: "#FFFFFFAA",
      marginBottom: "10px",
    },
    listContainer: {
      paddingLeft: "10px",
    },
    headerImg: {
      width: drawerWidth,
      padding: "10px",
    },
  }),
);

const useDashboardDrawer = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      drawer: {
        paper: styles.drawerPaper,
      },
      divider: {
        light: styles.lightDivider,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  const drawerModalProps = useMemo(() => {
    return { keepMounted: true };
  }, []);

  return {
    styles,
    classes,
    atomicStyles,
    drawerModalProps,
    t,
  };
};

export { useDashboardDrawer as default };
